






































import { apiPageConfigGetStateContentByApp } from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '在线课堂',
        }))
      }

      loading = computed(() => false)

      handleLoad = ({ pageNumber }: any) => {
        return apiPageConfigGetStateContentByApp({
          stateId: '8aaa8fa484cbd04c01850f46e6340327',
          pageIndex: pageNumber,
          pageSize: 10,
        })
      }
    },
)
